export const AUTH_ENTRYPOINT = process.env.REACT_APP_AUTH_ENDPOINT;
export const check_login = AUTH_ENTRYPOINT + '/api/login_check';
export const refreshTokenRoute = AUTH_ENTRYPOINT + '/refreshastotoken';

export const loginCondivisioneRoute =
    AUTH_ENTRYPOINT + `/api/condivisione/login_check`;

export const creaSeatsStripeRoute = (studioUuid) =>
    AUTH_ENTRYPOINT + `/api/stripe/${studioUuid}/seats`;
export const getConsulentiStudioRoute = (studioUuid) =>
    AUTH_ENTRYPOINT + `/studio/${studioUuid}/consulenti`;

export const restoreDocumentoRoute = (documentoId) =>
    AUTH_ENTRYPOINT + `/documento/${documentoId}/ripristina`;

export const getStudiUtenteRoute = (utenteUuid) =>
    AUTH_ENTRYPOINT + `/utenti/${utenteUuid}/studi`;
export const getStudioDocumentiRoute = (studioUuid) =>
    AUTH_ENTRYPOINT + `/api/admin/studio/${studioUuid}/documenti`;
export const getAdminDocumentoRoute = (documentoUuid) =>
    AUTH_ENTRYPOINT + `/api/admin/documenti/${documentoUuid}`;
export const getAdminutentiDocumentoRoute = (documentoUuid) =>
    AUTH_ENTRYPOINT + `/api/admin/documenti/${documentoUuid}/utenti`;

export const creaStudioRoute = AUTH_ENTRYPOINT + `/api/admin/studio`;

//TEMPLATE DOCUMENTO
export const getTemplateRoute = (documentoId) =>
    AUTH_ENTRYPOINT + `/templates/${documentoId}`;
export const favoriteTemplateRoute = (utenteUuid, templateUuid) =>
    AUTH_ENTRYPOINT + `/utenti/${utenteUuid}/templates/${templateUuid}`;
export const cambiaDraftRoute = (templateId) =>
    AUTH_ENTRYPOINT + `/templates/${templateId}/cambia_draft`;

// CLAUSOLE
export const clausoleBaseRoute = AUTH_ENTRYPOINT + `/clausole`;
export const rimuoviClausolaRoute = (id) => AUTH_ENTRYPOINT + `/clausole/${id}`;
export const exportClausoleRoute =
    AUTH_ENTRYPOINT + `/clausole_personali/export`;
export const rimuoviVisibilityStudioToClausolaRoute = (uuid) =>
    AUTH_ENTRYPOINT + `/clausole/${uuid}/remove_visibility`;
export const addVisibilityStudioToClausolaRoute = (uuid) =>
    AUTH_ENTRYPOINT + `/clausole/${uuid}/visibility`;

export const getStaffRoute = AUTH_ENTRYPOINT + `/staff`;

// ADMIN STUDIO
export const creaClausolaAIRoute = (studioUuid) =>
    AUTH_ENTRYPOINT + `/ai/${studioUuid}/clausole`;

// TERMS & CONDITIONS
export const termConditionBaseRoute = AUTH_ENTRYPOINT + `/termsandconditions`;

export const getTermConditionRoute = (uuid) =>
    `${termConditionBaseRoute}/${uuid}`;
export const updateTermConditionRoute = (uuid) =>
    `${termConditionBaseRoute}/${uuid}`;
export const deleteTermConditionRoute = (uuid) =>
    `${termConditionBaseRoute}/${uuid}`;
